import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useQuery, useQueryClient } from "react-query";
import {
  buyTicket,
  getRoom,
  getTicketByBill,
} from "../../services/game.service";

interface PopUpOpenProps {
  open: boolean;
  billId: string;
  onClose: () => void;
  onStartOpen: (data: any) => void;
}

export default function PopUpOpen({
  open,
  billId,
  onStartOpen,
  onClose,
}: PopUpOpenProps) {
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  const { data: billData, isLoading } = useQuery(
    ["get-ticket-data-by-bill", billId],
    async () => {
      // getTicketByBill() reads token from sessionStorage if not provided
      const response = await getTicketByBill({ billId });
      console.log("billData", response);
      return response;
    },
    {
      enabled: !!billId,
    }
  );
  const onSubmit = async () => {
    setLoading(true);
    try {
      onStartOpen(billData);
    } catch (error) {
      // errorAdd("ຊື້ບໍ່ສຳເລັດ"); // ถ้ามี sweetalert
      onClose();
    } finally {
      setLoading(false);
    }
  };

  if (isLoading && !billData) {
    return null;
  }

  return (
    <Modal
      show={open}
      onHide={onClose}
      keyboard={false}
      centered
      size="sm"
      contentClassName="rounded-[30px] max-w-[300px] mx-auto"
    >
      <Modal.Header
        style={{
          border: "none",
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        <Modal.Title
          style={{
            border: "none",
            textAlign: "center",
            justifyContent: "center",
            color: "#047431",
            fontWeight: "bold",
          }}
        >
          ຊື້ສະຫລາກສຳເລັດ
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: "flex", justifyContent: "center", padding: 10 }}>
          <img src="/images/undraw_check.png" style={{ width: "30%" }} />
        </div>
      </Modal.Body>
      <Modal.Footer style={{ border: "none", justifyContent: "center" }}>
        <Button
          variant="outline"
          disabled={loading}
          className="rounded-full px-4 py-2 border-2 border-[#D0903E] text-[#ffffff] font-bold"
          style={{
            background: "linear-gradient(to bottom, #FBE001 0%, #E87D00 100%)",
            borderColor: "#D0903E",
          }}
          onClick={onSubmit}
        >
          ເປີດສະຫລາກ
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
